<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref, watch} from "vue";
import Swal from "sweetalert2";
import router from "@/router";
import {useStore} from "vuex";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import $ from "jquery";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "OrdersInformation",
  components: {FooterPage, NavbarPage, LoadingPage},
  setup() {

    let store = useStore()
    let loading = ref(false)

    let address = ref([])
    let transport = ref([])

    let data = ref({
      type_order: store.state.order.products[0]?.type ?? null,
      address_id: null,
      transport_id: null,
      unit_id: store.state.order.products[0]?.unit_id ?? null,
      products: [],
      final_price: 0,
      transport_price: 0,
    })

    let factor = ref({
      counts: 0,
      all_price: 0,
      orders_profit: 0,
      final_price: 0,
      transport_price: 0
    })

    watch(() => data.value.transport_id, () => {
      if (!data.value.address_id) {
        Swals.Warning('آدرس مورد نظر خود را انتخاب یا وارد کنید')
        return false
      }

      get_info()
    })

    if (store.state.order.products.length <= 0) {
      router.push({name: 'HomePage'})
    } else {

      store.state.order.products.forEach((item) => {
        item.variable_id ? data.value.products.push({
          id: item.id,
          variable_id: item.variable_id,
          count: item.order_count_select,
          installer: item.select_installer,
        }) : data.value.products.push({
          id: item.id,
          variable_id: '',
          count: item.order_count_select,
          installer: item.select_installer,
        })
      })

    }

    function get_info() {

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'info_shopping_cart', true).then((res) => {

        if (res.data.event === "number of products is not enough") {

          Swal.fire({
            position: 'center-center',
            icon: 'error',
            title: 'متاسفانه موجودی محصولات سفارش داده شده از موجودی فروشگاه بیشتر است!',
            confirmButtonText: 'فهمیدم',
            allowOutsideClick: false,
          }).then(() => {
            router.push({name: 'OrdersPage'})
          })

        }

        if (res.data.event === "unit id is wrong") {
          Swal.fire({
            position: 'center-center',
            icon: 'error',
            title: 'شما فقط میتوانید از یک فروشگاه محصولات خود را انتخاب کنید!',
            confirmButtonText: 'فهمیدم',
          }).then(() => {
            store.commit('EmptyBasket')
            router.push({name: 'HomePage'})
          })
        }


        loading.value = false
        address.value = res.data.show_address
        transport.value = res.data.show_transport

        factor.value.counts = res.data.product_item
        factor.value.all_price = res.data.product_price
        factor.value.final_price = res.data.final_price
        factor.value.transport_price = res.data.transport_price
        factor.value.orders_profit = res.data.product_profit

        data.value.transport_price = res.data.transport_price
        data.value.final_price = res.data.final_price

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_info)
      })

    }

    get_info()

    function delete_address(item) {

      Swals.Question('آیا از حذف این آدرس اطمینان دارید؟', 'حذف کردن').then((res) => {
        if (res.isConfirmed) {
          loading.value = true
          FreeWorld.Heisenberg({action: 'delete', address_id: item.id}, 'user_address').then((res) => {

            loading.value = false
            if (res.data.status === 'ok') {

              Swals.Done('آدرس مورد نظر شما با موفقیت حذف شد')
              $("#Address" + item.id).removeClass('animate__fadeInDown').addClass('animate__backOutDown')

              setTimeout(() => {
                get_info()
              }, 500)

            } else {
              Swals.Fault('متاسفانه آدرس مورد نظر شما حذف نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => delete_address(item))
          })


        }
      })

    }

    function closing_page() {

      Swal.fire({
        text: "آیا میخواهید سبد خرید را لغو کنید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "لغو میکنم",
        cancelButtonText: "منصرف شدم",
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {

        if (result.isConfirmed) {

          store.commit('EmptyBasket')

          Swal.fire({
            text: "سبد خرید شما لغو شد",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            router.push({name: 'HomePage'})
          })
        }

      })

    }

    function next_page() {

      if (!data.value.address_id) {
        Swals.Warning('لطفا آدرس را انتخاب کنید')
        return false
      }

      if (!data.value.transport_id) {
        Swals.Warning('لطفا روش حمل و نقل را انتخاب کنید')
        return false
      }

      store.commit('set_information_orders', data.value)

      router.push({name: 'OrdersPayment'})

    }

    return {
      loading,
      closing_page,
      delete_address,
      data,
      address,
      factor,
      transport,
      next_page,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div :class="loading ? 'activeClass' : '' " id="main" class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
      <div @click="closing_page" class="d-flex align-items-center">
        <p class="m-0">
          انصراف
        </p>
        <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
      </div>
      <div class="d-flex align-items-center">
        <p class="m-0">
          اطلاعات سفارش
        </p>
        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body">

      <div class="mt-4">
        <div class="rounded-4 bg-white p-3 mb-3 shadow-custom">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="font-4 font-bold m-0">آدرس</p>

            <router-link :to="{name:'AddAddress'}" class="text-decoration-none d-flex align-items-center">
              <img style="width: 2rem;height: 2rem" src="../assets/img/add_icon.svg" alt="" class="ml-2">
              <p class="font-5 font-color m-0">افزودن آدرس</p>
            </router-link>
          </div>

          <hr>

          <div class="list_address">

            <div v-for="item in address" :key="item.id"
                 :class="data.address_id === item.id ? 'bg_select':'bg-white' " :id="'Address' + item.id"
                 class="animate__animated animate__fadeInDown d-flex align-items-center justify-content-between p-2 shadow-custom rounded-3 mb-2">
              <div @click="data.address_id = item.id" class="d-flex align-items-center w-85">
                <img style="width: 2rem;height: 2rem" class="" src="../assets/img/address_color.svg" alt="">

                <p class="font-5 mr-2 mb-0 w-80">{{ item.address }}</p>
              </div>

              <img @click="delete_address(item)" style="width: 3rem;height: 3rem"
                   src="../assets/img/delete_albom.svg" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="rounded-4 bg-white p-3 mb-3 shadow-custom">
        <p class="font-4 font-bold m-0">انتخاب روش حمل و نقل</p>

        <hr>

        <div v-for="item in transport" :key="item.id" class="d-flex justify-content-between align-items-center mb-3">
          <div class="w-70 d-flex align-items-center">
            <input :disabled="!data.address_id" :id="'transport' + item.id" type="radio" v-model="data.transport_id"
                   :value="item.id">
            <label class="me-2 w-85 font-3" :for="'transport' + item.id">{{ item.title }}</label>
          </div>

          <p v-if="data.transport_price > 0 && data.transport_id === item.id" class="font-4 font-color m-0">
            {{ data.transport_price.toLocaleString() }}</p>
        </div>

      </div>

      <div class="">
        <div class="bg-white p-3 rounded-4">
          <p class="m-0 text-center font-3 font-bold">
            جزئیات پرداخت
          </p>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              تعداد اقلام
            </p>
            <p class="m-0 font-4">{{ factor.counts }}</p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              جمع کل قبل از تخفیف
            </p>

            <p class="m-0 d-flex font-4">
              <span>{{ factor.all_price.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>

            </p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              سود شما از این خرید
            </p>

            <p class="m-0 d-flex font-4">
              <span>{{ factor.orders_profit.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>

            </p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              هزینه حمل و نقل
            </p>

            <p class="m-0 d-flex font-4">
              <span>{{ factor.transport_price.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>

            </p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between bg-main px-1 py-3 rounded-3">
            <p class="m-0 font-4">
              مبلغ قابل پرداخت
            </p>

            <p class="m-0 d-flex font-4 font-bold font-color-green">
              <span>{{ factor.final_price.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>
            </p>
          </div>
        </div>
      </div>

    </div>

    <br>
    <br>
    <br>
    <br>

    <div class="button_div w-100 d-flex justify-content-center p-body">
      <v-btn @click="next_page" class="w-100 h-75 mx-4 font-4 bg-color rounded-pill border-costom text-white my-2">
        بعدی
      </v-btn>
    </div>
  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-3 w-75 ma-auto">اطلاعات سفارش</div>

    <div class="w-75 ma-auto rounded-4">

      <div class="mt-4">
        <div class="rounded-4 bg-white p-3 mb-3 shadow-custom">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="font-4 font-bold m-0">آدرس</p>

            <router-link :to="{name:'AddAddress'}" class="text-decoration-none d-flex align-items-center">
              <img style="width: 2rem;height: 2rem" src="../assets/img/add_icon.svg" alt="" class="ml-2">
              <p class="font-5 font-color m-0">افزودن آدرس</p>
            </router-link>
          </div>

          <hr>

          <div class="list_address">

            <div v-for="item in address" :key="item.id"
                 :class="data.address_id === item.id ? 'bg_select':'bg-white' " :id="'Address' + item.id"
                 class="animate__animated animate__fadeInDown d-flex align-items-center justify-content-between p-2 shadow-custom rounded-3 mb-2">
              <div @click="data.address_id = item.id" class="d-flex align-items-center w-85">
                <img style="width: 2rem;height: 2rem" class="" src="../assets/img/address_color.svg" alt="">

                <p class="font-5 mr-2 mb-0 w-80">{{ item.address }}</p>
              </div>

              <img @click="delete_address(item)" style="width: 3rem;height: 3rem"
                   src="../assets/img/delete_albom.svg" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="rounded-4 bg-white p-3 mb-3 shadow-custom">
        <p class="font-4 font-bold m-0">انتخاب روش حمل و نقل</p>

        <hr>

        <div v-for="item in transport" :key="item.id" class="d-flex justify-content-between align-items-center mb-3">
          <div class="w-70 d-flex align-items-center">
            <input :disabled="!data.address_id" :id="'transport' + item.id" type="radio" v-model="data.transport_id"
                   :value="item.id">
            <label class="me-2 w-85 font-3" :for="'transport' + item.id">{{ item.title }}</label>
          </div>

          <p v-if="data.transport_price > 0 && data.transport_id === item.id" class="font-4 font-color m-0">
            {{ data.transport_price.toLocaleString() }}</p>
        </div>

      </div>

      <div class="">
        <div class="bg-white p-3 rounded-4">
          <p class="m-0 text-center font-3 font-bold">
            جزئیات پرداخت
          </p>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              تعداد اقلام
            </p>
            <p class="m-0 font-4">{{ factor.counts }}</p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              جمع کل قبل از تخفیف
            </p>

            <p class="m-0 d-flex font-4">
              <span>{{ factor.all_price.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>

            </p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              سود شما از این خرید
            </p>

            <p class="m-0 d-flex font-4">
              <span>{{ factor.orders_profit.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>

            </p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between">
            <p class="m-0 font-4">
              هزینه حمل و نقل
            </p>

            <p class="m-0 d-flex font-4">
              <span>{{ factor.transport_price.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>

            </p>
          </div>
          <hr>
          <div class="d-flex align-items-center justify-content-between bg-main px-1 py-3 rounded-3">
            <p class="m-0 font-4">
              مبلغ قابل پرداخت
            </p>

            <p class="m-0 d-flex font-4 font-bold font-color-green">
              <span>{{ factor.final_price.toLocaleString() }}</span>
              &nbsp;
              <span>تومان</span>
            </p>
          </div>
        </div>
      </div>

      <br>
      <br>

      <div class="button_div_web w-100 d-flex justify-content-center p-body">
        <v-btn @click="next_page" class="w-75 h-75 mx-4 bg-color rounded-pill border-costom text-white my-2">
          بعدی
        </v-btn>
      </div>
    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}

.button_div_web {
  height: 80px;
}

.bg_select {
  background-color: rgba(255, 153, 0, 0.37);
}

</style>